import { DATE_FORMATS, formatStartTime } from '@/helpers/date'

export const getProgramTitle = ({
  programTitle,
  startTimeMs,
}: {
  programTitle?: string
  startTimeMs?: number
}): string => {
  if (!programTitle || !startTimeMs) return ''

  const programTitleF = programTitle
  const startTimeF = formatStartTime(startTimeMs, DATE_FORMATS.HH_MM_LOCALIZED)
  return `${startTimeF} • ${programTitleF}`
}
